export const defaultCities = {
    de: {
        name: "Berlin",
        code: "DE0001020",
        seoString: "deutschland/berlin",
        slug: "deutschland/berlin/DE0001020.html",
        countryCode: "DE",
    },
    at: {
        name: "Wien",
        code: "ATAT10678",
        seoString: "oesterreich/wien",
        slug: "oesterreich/wien/ATAT10678.html",
        countryCode: "AT",
    },
    ch: {
        name: "Bern",
        code: "CH0CH0324",
        seoString: "schweiz/bern",
        slug: "schweiz/bern/CH0CH0324.html",
        countryCode: "CH",
    },
    pl: {
        name: "Warszawa",
        code: "PL0MZ0005",
        seoString: "polska/warszawa",
        slug: "polska/warszawa/PL0MZ0005/",
        countryCode: "PL",
    },
    cs: null,
    da: null,
    es: null,
    fr: null,
    it: null,
    nl: null,
    ro: null,
    sk: null,
    sv: null,
    us: null,
    uk: null,
};
